import { useEffect, useRef, useState } from "react";
import { truncate } from "../../utils/truncate";
import InviteTeam from "../InviteTeam";
import "./Team.css";

const Team = () => {
  const [addTeam, setAddTeam] = useState(false);
  const teamNameContainer = useRef(null);
  const [teamName, setTeamName] = useState("Team Name");
  const [editTeamName, setEditTeamName] = useState(false);

  const handleChangeLogoImage = async (e) => {
    // for send image team
    const file = e.target.files[0];
    const bodyFormData = new FormData();
    bodyFormData.append("image", file);
    try {
      // for later to send to the backend
      // const { data } = await Axios.post("", bodyFormData, {
      //   headers: {
      //     "Content-Type": "multipart/form-data",
      //     Authorization: `Bearer ${aboutUser.token}`,
      //   },
      // });
      // setLoadingUpload(true);
      // setImage(data);
      // setLoadingUpload(false);
    } catch (err) {
      // setLoadingUpload(true);
      // setErrorUpload(err.message);
      // setLoadingUpload(false);
    }
  };

  const handleEditTeamName = (e) => {
    setEditTeamName(true);
    setTimeout(() => {
      teamNameContainer.current.focus();
    }, 0);
  };

  const handleChangeTeamName = (e) => {
    setTeamName(e.target.innerText);
  };

  useEffect(() => {
    window.onclick = (e) => {
      if (e.target.closest("#team-name") === null) {
        setEditTeamName(false);
      }
    };
  }, []);

  return (
    <div className="team">
      <div className="flex-row">
        <h3>Create your team</h3>
        <p
          id="team-name"
          ref={teamNameContainer}
          className={`btn primary ${editTeamName && "edit-team-name"} `}
          contentEditable={editTeamName}
          onClick={handleEditTeamName}
          onKeyPress={handleChangeTeamName}
        >
          {editTeamName ? "" : teamName}
        </p>
      </div>
      <ul>
        <li>
          <div className="team__user">
            <img
              src="https://gist.githubusercontent.com/faustabmnyh/070481fe272d83fc3cc0cd704121a794/raw/f3033fc51696957b3274f24b868d6fb8473a7241/ex-logo-team.svg"
              alt=""
            />
            <div className="team__logoImageOverlay">
              <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
                <path d="M28.7 6C30.64 6.01998 32.22 7.01887 33.14 8.81687C33.3775 9.29134 33.7088 9.98432 34.0556 10.7153L34.4744 11.5993L34.68 12.0333L34.88 12.4728C34.96 12.6127 35.1 12.7125 35.28 12.7125C40.08 12.7125 44 16.6282 44 21.4229V33.2897C44 38.0844 40.08 42 35.28 42H12.72C7.9 42 4 38.0844 4 33.2897V21.4229C4 16.6282 7.9 12.7125 12.72 12.7125C12.88 12.7125 13.04 12.6326 13.1 12.4728L13.22 12.2331C13.78 11.0544 14.46 9.61598 14.86 8.81687C15.78 7.01887 17.34 6.01998 19.28 6H28.7ZM24 18.8058C21.9 18.8058 19.92 19.6249 18.42 21.1232C16.94 22.6215 16.12 24.5794 16.14 26.657C16.14 28.7547 16.96 30.7125 18.44 32.2109C19.94 33.6892 21.9 34.5083 24 34.5083C26.16 34.5083 28.12 33.6293 29.54 32.2109C30.96 30.7925 31.84 28.8346 31.86 26.657C31.86 24.5794 31.04 22.6016 29.56 21.1032C28.08 19.6249 26.1 18.8058 24 18.8058ZM24 21.8024C25.3 21.8024 26.52 22.3019 27.44 23.2209C28.36 24.1398 28.86 25.3585 28.86 26.657C28.84 29.3341 26.68 31.5117 24 31.5117C22.7 31.5117 21.48 31.0122 20.56 30.0932C19.64 29.1743 19.14 27.9556 19.14 26.657V26.6371C19.12 25.3785 19.62 24.1598 20.54 23.2408C21.48 22.3019 22.7 21.8024 24 21.8024ZM35.22 18.3263C34.22 18.3263 33.42 19.1454 33.42 20.1443C33.42 21.1432 34.22 21.9423 35.22 21.9423C36.22 21.9423 37.04 21.1432 37.04 20.1443C37.04 19.1454 36.22 18.3263 35.22 18.3263Z" />
              </svg>
              <input
                type="file"
                className="team__imgOverlayImgInput"
                accept="image/*"
                onChange={handleChangeLogoImage}
              />
            </div>
            {/* <div className="team__userDescription">
              <h3>{truncate(teamName, 20)} </h3>
            </div> */}
          </div>
        </li>
        <li>
          <div className="team__user">
            <img src="https://images.unsplash.com/photo-1554126807-6b10f6f6692a?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=870&q=80" alt="" />
            <div className="team__userDescription">
              <h3>{truncate("Abraham Benjamin", 20)} </h3>
              <span>Not assigned yet</span>
            </div>
          </div>
        </li>

        <li onClick={() => setAddTeam(true)}>
          <div>
            <svg
              viewBox="0 0 45 45"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M41.49 18.99H26.01V3.52002C26.01 1.57002 24.44 0 22.5 0C20.56 0 18.98 1.57002 18.98 3.52002V18.99H3.51001C1.57001 18.99 0 20.56 0 22.5C0 24.44 1.57001 26.01 3.51001 26.01H18.98V41.49C18.98 43.43 20.56 45 22.5 45C24.44 45 26.02 43.43 26.02 41.49V26.01H41.48C43.43 26.01 45 24.44 45 22.5C45 20.56 43.43 18.99 41.49 18.99Z"
                fill="#D0D8F2"
              />
            </svg>
          </div>
        </li>
        <li onClick={() => setAddTeam(true)}>
          <div>
            <svg
              viewBox="0 0 45 45"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M41.49 18.99H26.01V3.52002C26.01 1.57002 24.44 0 22.5 0C20.56 0 18.98 1.57002 18.98 3.52002V18.99H3.51001C1.57001 18.99 0 20.56 0 22.5C0 24.44 1.57001 26.01 3.51001 26.01H18.98V41.49C18.98 43.43 20.56 45 22.5 45C24.44 45 26.02 43.43 26.02 41.49V26.01H41.48C43.43 26.01 45 24.44 45 22.5C45 20.56 43.43 18.99 41.49 18.99Z"
                fill="#D0D8F2"
              />
            </svg>
          </div>
        </li>
        <li onClick={() => setAddTeam(true)}>
          <div>
            <svg
              viewBox="0 0 45 45"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M41.49 18.99H26.01V3.52002C26.01 1.57002 24.44 0 22.5 0C20.56 0 18.98 1.57002 18.98 3.52002V18.99H3.51001C1.57001 18.99 0 20.56 0 22.5C0 24.44 1.57001 26.01 3.51001 26.01H18.98V41.49C18.98 43.43 20.56 45 22.5 45C24.44 45 26.02 43.43 26.02 41.49V26.01H41.48C43.43 26.01 45 24.44 45 22.5C45 20.56 43.43 18.99 41.49 18.99Z"
                fill="#D0D8F2"
              />
            </svg>
          </div>
        </li>
      </ul>
      {addTeam && <InviteTeam setAddTeam={setAddTeam} />}
    </div>
  );
};

export default Team;
